import { Stack, Box, Typography } from "@mui/material";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import ServiceRightButton from "./ServiceRightButton";
import React from "react";

const ServiceRightForm = () => {
  return (
    <>
      <Stack
        alignItems={{ md: "center", sm: "center", xs: "flex-start" }}
        spacing={4}
        paddingTop={7}
        paddingLeft={{ xs: 5 }}
      >
        <Box bgcolor={"#F7F7F7"} borderRadius={"8px"}>
          <Box component={"img"} src="/assets/icons/Productimage.png" />
        </Box>

        <Typography
          fontSize={{ md: "36px", sm: "36px", xs: "30px" }}
          fontWeight={700}
          textAlign={{ md: "center", xs: "start" }}
        >
          $250.00
        </Typography>
      </Stack>
      <Stack
        direction={{ md: "column", sm: "column", xs: "column" }}
        justifyContent={"flex-start"}
        margin={3}
        spacing={{ md: 2, sm: 2, xs: 3 }}
      >
        <Stack
          spacing={3}
          direction={{ md: "row", sm: "row", xs: "column" }}
          width={{ md: "497px", sm: "497px", xs: "271px" }}
        >
          <Box>
            <Typography
              fontSize={{ md: "13px", sm: "13px", xs: "13px" }}
              fontWeight={400}
            >
              Product Name
            </Typography>
            <Box
              border={"0.95px solid #E8EAED"}
              borderRadius={"11.36px"}
              // padding={"7.58px, 15.15px, 7.58px, 15.15px"}
              paddingY={1}
              paddingRight={20}
              paddingLeft={1.5}
              marginTop={1}
            >
              <Typography
                fontSize={{ md: "13px", sm: "13px", xs: "13px" }}
                fontWeight={400}
              >
                Sanchez Bag
              </Typography>
            </Box>
          </Box>
          <Box>
            <Typography fontSize={"13px"} fontWeight={400}>
              Product Price
            </Typography>
            <Box
              border={"0.95px solid #E8EAED"}
              borderRadius={"11.36px"}
              // padding={"7.58px, 15.15px, 7.58px, 15.15px"}
              paddingY={1}
              paddingRight={20}
              paddingLeft={1.5}
              marginTop={1}
            >
              <Typography fontSize={"13px"} fontWeight={400}>
                $250.00
              </Typography>
            </Box>
          </Box>
        </Stack>

        {/* for product description */}
        <Box
          width={{ md: "497px", sm: "497px", xs: "271px" }}
          height={{ md: "", sm: "105px", xs: "105px" }}
        >
          <Typography fontSize={"13px"} fontWeight={400}>
            Product Description
          </Typography>
          <Box
            border={"0.95px solid #E8EAED"}
            borderRadius={"11.36px"}
            paddingTop={1}
            paddingBottom={7}
            paddingRight={20}
            paddingLeft={1.5}
            marginTop={1}
          >
            <Typography fontSize={"13px"} fontWeight={400}>
              Sanchez Bag
            </Typography>
          </Box>
        </Box>
      </Stack>
      <Stack
        direction={{ md: "row", sm: "row", xs: "column" }}
        spacing={{ md: 12, sm: 12, xs: 2 }}
        justifyContent={"flex-start"}
        // paddingTop={1}
        paddingLeft={{ xs: 5 }}
      >
        <Box>
          <Stack direction={"row"} spacing={1}>
            <RadioButtonCheckedIcon fontSize="small" color="secondary" />
            <Typography fontSize={"13px"} fontWeight={400}>
              Single Payment
            </Typography>
          </Stack>
        </Box>
        <Box>
          <Stack direction={"row"} spacing={1}>
            <RadioButtonUncheckedIcon fontSize="small" color="primary" />
            <Typography fontSize={"13px"} fontWeight={400}>
              Recurring Payment
            </Typography>
          </Stack>
        </Box>
      </Stack>
      <Stack
        direction={"row"}
        justifyContent={"center"}
        // padding={4}
        marginY={{ md: 4, sm: 4, xs: 4 }}
      >
        <ServiceRightButton />
      </Stack>
    </>
  );
};

export default ServiceRightForm;
